import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
// Images
import AlcaldiaMedIcon from "../../../assets/logo_mobile_header.png";
import EscudoAlcaldiaBlanco from "../../../assets/landing/logo3.png";
import { FaBars } from "react-icons/fa";
import { CgClose, CgSearch } from "react-icons/cg";
import { BsPersonPlus, BsPerson, BsPersonX } from "react-icons/bs";
import { Drawer } from "antd";
import { useLocation, NavLink } from "react-router-dom";
// styles
import "./headerMobile.scss";

interface IProps {
   className?: string;
}

export const HeaderMobile: React.FC<IProps> = (props: IProps) => {
   const navigate = useNavigate();
   const [drawerVisible, setDrawerVisible] = useState(false);
   const openDrawer = () => setDrawerVisible(true);
   const onClose = () => {
      setDrawerVisible(false);
   };
   const [isLogged, setisLogged] = useState<any>(false)

   useEffect(() => {
      const user = localStorage.getItem('user')
      if (user) {
         setisLogged(true)
      }
   }, [localStorage.token])

   const location = useLocation();
   const isPPSection = location.pathname.startsWith('/pp');

   return (
      <div className="nav_mobile">
         <div className="bus_nav_top2 grid_menumobile_" title="Menú">
            {
               drawerVisible ?
                  <CgClose onClick={onClose}></CgClose> :
                  <FaBars onClick={openDrawer}></FaBars>
            }
            <Drawer
               className="drawerAdjust"
               width={360}
               placement="left"
               onClose={onClose}
               visible={drawerVisible}
               footer={
                  <div className="zocalo_menu d-flex flex-row justify-content-between align-content-center align-items-center">
                     <div className="z_alcalmed d-flex">
                        <div className="iconosmed_">
                           <a href="https://www.medellin.gov.co/es">
                              <img src={EscudoAlcaldiaBlanco} className="img-fluid" style={{ maxHeight: "30px" }} />
                           </a>
                        </div>
                        <a href="https://www.medellin.gov.co/es">
                           <span className="namealcaldia">Alcaldía de Medellín</span>
                        </a>
                     </div>
                     <div className="z_govier d-flex">
                        <img width="2530" height="546" src="https://cdnwordpresstest-f0ekdgevcngegudb.z01.azurefd.net/es/wp-content/themes/theme_alcaldia/img/logo_gov.png" alt="" />
                     </div>
                  </div>
               }
            >  <div>
                  <div className="mobile_menu">
                     <div className="login_mobile">
                        {isLogged ?
                        <div  onClick={() => {
                           localStorage.removeItem("token");
                           localStorage.removeItem("user");
                           localStorage.clear();
                           navigate("/")
                        }}
                        className="login collapsed" data-toggle="collapse" id="HIniciarS" aria-expanded="false"
                        role="button"
                        onKeyDown={(e) => {
                           if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              localStorage.removeItem("token");
                              localStorage.removeItem("user");
                              localStorage.clear();
                              navigate("/")
                           }
                        }}
>
                        <BsPersonX></BsPersonX>
                        <p>Cerrar Sesión</p>
                     </div>
                     :
                           <>
                              <div onClick={() => navigate("/login")}
                                    className="login collapsed"
                                    data-toggle="collapse"
                                    id="HIniciarS"
                                    aria-expanded="false"
                                    role="button"
                                    onKeyDown={(e) => {
                                       if (e.key === "Enter" || e.key === " ") {
                                          e.preventDefault();
                                          navigate("/login")
                                       }
                                    }}
                                 >
                                 <BsPerson></BsPerson>
                                 <p>Iniciar Sesión</p>
                              </div>
                              <div onClick={() => { window.location.href = "https://www.medellin.gov.co/registrate"; }}
                                 className="registro"
                                 role="button"
                                 onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                       e.preventDefault();
                                       window.location.href = "https://www.medellin.gov.co/registrate";
                                    }
                                 }}
                                 >
                                 <BsPersonPlus></BsPersonPlus>
                                 {/* <ion-icon name="person-add-outline" role="img" className="md hydrated" aria-label="person add outline"></ion-icon> */}
                                 <p>Regístrese</p>
                              </div>
                           </>
                        }

                     </div>
                     <div className="menu_categorias_">
                        <ul>
                           <div className="menu-menu-mobile-container">
                              <ul id="menu-menu-mobile" className="">
                                 {isPPSection ? (
                                  <>
                                    <li id="menu-item-54581" className="menu-item menu-item-type-custom menu-item-object-custom titulo_ente_ menu-item-54580"><a onClick={() => navigate("/pp")} role="button" onKeyDown={(e) => {
                                                                                                                                                                if (e.key === "Enter" || e.key === " ") {
                                                                                                                                                                    e.preventDefault();
                                                                                                                                                                    navigate("/pp");
                                                                                                                                                                }
                                                                                                                                                              }}><b>Inicio</b></a></li>
                                    <li id="menu-item-54581" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-54581"><NavLink to="/ppestimulos">Estímulos PP</NavLink></li>
                                    <li id="menu-item-54582" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-54582"><NavLink to="/ppformacion">Formación</NavLink></li>
                                    <li id="menu-item-54584" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-54584"><NavLink to="/ppfortalecimiento">Fortalecimiento</NavLink></li>
                                    <li id="menu-item-7100" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7100"><NavLink to="/ppagenda">Agenda PP</NavLink></li>
                                    <li id="menu-item-54585" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-54585"><NavLink to="/ppcic">CIC</NavLink></li>
                                    <li id="menu-item-54585" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-54585"><NavLink to="/">Estímulos Cultura</NavLink></li>
                                  </>
                                 ) : (
                                  <>
                                    <li id="menu-item-54581" className="menu-item menu-item-type-custom menu-item-object-custom titulo_ente_ menu-item-54580"><a onClick={() => navigate("/")} role="button" onKeyDown={(e) => {
                                                                                                                                                                if (e.key === "Enter" || e.key === " ") {
                                                                                                                                                                    e.preventDefault();
                                                                                                                                                                    navigate("/");
                                                                                                                                                                }
                                                                                                                                                              }}><b>Convocatorias</b></a></li>
                                    <li id="menu-item-54581" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-54581"><NavLink to="/beneficiarios">Beneficiarios</NavLink></li>
                                    <li id="menu-item-54584" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-54584"><NavLink to="/agenda">Agenda cultural</NavLink></li>
                                    <li id="menu-item-7100" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7100"><NavLink to="/mentorias">Mentorías</NavLink></li>
                                    <li id="menu-item-7100" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7100"><NavLink to="/form">Formularios</NavLink></li>
                                    <li id="menu-item-54582" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-54582"><NavLink to="/lep">LEP</NavLink></li>
                                    <li id="menu-item-54585" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-54585"><NavLink to="/pp">PP</NavLink></li>
                                  </>
                                  )
                                 }
                              </ul>
                           </div>
                        </ul>
                     </div>
                  </div>
               </div>

            </Drawer>
         </div>
         <div className="logo_flex">
            <div className="logo_alcaldia_22 colormobil">
               <a href="https://www.medellin.gov.co/es/">
                  <img className="img_logo_mobile" src={AlcaldiaMedIcon} />
               </a>
            </div>
         </div>
         <div className="bus_nav_top" data-toggle="modal" data-target="#exampleModal" title="Buscador">
            <a id="HBuscador" href="https://www.medellin.gov.co/es/?s=" data-toggle="modal" data-target="#exampleModal" title=" Busca, explora y encuentra todo lo que la Alcaldía tiene para ti">
               <CgSearch color="white"></CgSearch>
            </a>
         </div>

      </div>


   );
};
